export function setInactiveEffect(target, canvas, fire = true) {
    if (target) {
        target.active = false
        target.selected = false
        fire && canvas.fire('inactivate', target.id)
    } else {
        console.warn('设置对象选中状态异常')
    }
}

export function setTargetActiveByEvent(canvas, event) {
    event.e.stopPropagation()
    canvas.forEachObject(item => {
        setInactiveEffect(item, canvas)
    })
    canvas.discardActiveObject(event)
    canvas.renderAll()
}
